const data = {
  steps: [
    {
      title: 'Do it your way',
      description:
        'Create the send-off you want, when you’re ready. With more time to grieve, plan, and get everyone together.',
      illustration: 'why-people-are-choosing',
    },
    {
      title: 'It’s simpler',
      description:
        'Cut the extra fuss and burden of a traditional funeral. Things like a hearse, an organist, or arranging a procession.',
      illustration: 'direct-cremation',
    },
    {
      title: 'It’s cheaper',
      description:
        'We’re 4x cheaper than the average traditional UK funeral, saving you thousands.',
      illustration: 'fair-on-price',
    },
  ],
  title: 'Direct cremation.',
  title2: 'It’s a funeral done your way.',
  subtitle:
    'Direct cremation is simply a cremation without a funeral service. It’s fast becoming the choice of families who want to decide how and where they say goodbye to their loved one, at a time that’s right for them.',
  description1:
    'Create the send-off you want, when you’re ready. With more time to grieve, plan, and get everyone together.',
  description2:
    'Cut the extra fuss and burden of a traditional funeral. Things like a hearse, an organist, or arranging a procession.',
  description3:
    'We’re 4x cheaper than the average traditional UK funeral, saving you thousands.',
}

export default data
